import { useTranslation } from "../../i18n";

function DeliveryViewToggle({ mode, onChange }) {
    const { t } = useTranslation();
    const isWaterfall = mode === "waterfall";

    return (
        <div className="delivery-view-toggle" role="group" aria-label={t("delivery.actions.viewMode")}>
            <span
                className={`delivery-view-toggle__label${
                    isWaterfall ? " delivery-view-toggle__label--active" : ""
                }`}
            >
                {t("delivery.actions.viewWaterfall")}
            </span>
            <button
                type="button"
                className={`delivery-view-toggle__track${isWaterfall ? " delivery-view-toggle__track--on" : ""}`}
                role="switch"
                aria-checked={isWaterfall}
                onClick={() => onChange(isWaterfall ? "grid" : "waterfall")}
                aria-label={isWaterfall ? t("delivery.actions.viewWaterfall") : t("delivery.actions.viewGrid")}
            >
                <span className="delivery-view-toggle__thumb" />
            </button>
        </div>
    );
}

export default DeliveryViewToggle;
